<template>
  <div class="content">
    <h1 class="title">{{ $t("capacity.title") }}</h1>
    <div class="table">
      <div class="inputs">
        <v-row>
          <v-col cols="12" xs="12" lg="3" md="4" sm="6">
            <v-text-field
              :label="$t('capacity.productNameLabel')"
              v-model="product_name"
              @keydown.enter="handleFilter(false)"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" lg="3" md="4" sm="6" v-if="isSuperAdmin">
            <v-select
              :label="$t('capacity.partnerLabel')"
              v-model="partner"
              :items="partnersWithId"
              item-title="name"
              item-value="id"
              clearable
              @keydown.enter="handleFilter(false, true)"
              :readonly="enterClicked ? true : false"
            ></v-select>
          </v-col>
        </v-row>
        <v-btn @click="handleFilter(false)">{{
          $t("capacity.filterButton")
        }}</v-btn>
      </div>
      <div>
        <v-data-table
          v-if="!isLoading"
          :headers="headers"
          :items="anomalyEvents"
          disable-sort
          hide-default-footer
          :items-per-page="-1"
          class="elevation-0"
        >
          <template v-slot:[`item.due_date`]="{ item }">
            {{ formatDateString(item.selectable.due_date) }}
          </template>
          <template v-slot:[`item.max_capacity`]="{ item }">
            {{ item.selectable.max_capacity + " fő" }}
          </template>
          <template v-slot:[`item.used_capacity`]="{ item }">
            {{ item.selectable.used_capacity + " fő" }}
          </template>
          <template v-slot:[`item.capacity_percent`]="{ item }">
            {{ item.selectable.capacity_percent + "%" }}
          </template>
          <template v-slot:[`item.weather`]="{ item }">
            {{ item.selectable.weather + "°C" }}
          </template>
          <template v-slot:no-data>
            <Vue3Lottie
              :animationData="NoDataLottie"
              :height="200"
              :width="200"
            />
            <div class="pb-5 table-no-data">
              <h3>{{ $t("tableNoDataTitle") }}</h3>
              <p>{{ $t("tableNoDataDesc") }}</p>
            </div>
          </template>
          <template v-slot:bottom>
            <div class="botSide">
              <v-row align="center" justify-sm="end" justify="center" class="px-2">
                <v-col cols="12" xs="12" lg="3" md="4" sm="6">
                  <v-row align="center" justify="end"
                    ><div class="pr-2 pageSelectorLabel">
                      {{ $t("anomaly.tableFooterText") }}
                    </div>
                    <v-select
                      v-model="limit"
                      hide-details
                      @update:model-value="handleFilter(false)"
                      :items="pageSizes"
                      class="pageSelector pl-5"
                    ></v-select>
                    <div class="pl-2">
                      {{ displayRange }}
                    </div>
                  </v-row>
                </v-col>
                <v-col
                  cols="12"
                  xs="12"
                  lg="3"
                  md="4"
                  sm="5"
                  class="pl-1 pr-1 pagination"
                >
                  <v-pagination
                    v-model="page"
                    :length="pageCount"
                    rounded="circle"
                    :total-visible="1"
                    show-first-last-page="true"
                    @update:model-value="handleFilter(true)"
                  ></v-pagination>
                </v-col>
              </v-row>
            </div>
          </template>
        </v-data-table>
      </div>
      <v-card v-if="isLoading" class="loading">
        <v-progress-circular
          v-if="isLoading"
          size="73.5"
          indeterminate
          class="loading-circle"
        ></v-progress-circular>
      </v-card>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { Vue3Lottie } from "vue3-lottie";
import NoDataLottie from "@/assets/lotties/nodatalottie.json";

export default {
  name: "Capacity",
  props: {},
  components: {
    Vue3Lottie,
  },
  data() {
    return {
      NoDataLottie,
      headers: [
        {
          title: this.$t("capacity.table.headers.par_name"),
          key: "partner.par_name",
          align: "start",
          sortable: false,
        },
        {
          title: this.$t("capacity.table.headers.name"),
          key: "name",
          sortable: false,
        },
        {
          title: this.$t("capacity.table.headers.due_date"),
          key: "due_date",
          sortable: false,
        },
        {
          title: this.$t("capacity.table.headers.max_capacity"),
          key: "max_capacity",
          sortable: false,
        },
        {
          title: this.$t("capacity.table.headers.used_capacity"),
          key: "used_capacity",
          sortable: false,
        },
        {
          title: this.$t("capacity.table.headers.capacity_percent"),
          key: "capacity_percent",
          sortable: false,
        },
        {
          title: this.$t("capacity.table.headers.weather"),
          key: "weather",
          sortable: false,
        },
      ],

      //Pagination settings
      page: undefined,
      limit: undefined,
      total: 0,
      pageSizes: [10, 25, 50, 100],

      //For Search
      product_name: undefined,
      partner: undefined,
      partnersWithId: [],

      anomalyEvents: [],

      isLoading: false,
      error: false,

      enterClicked: false,
    };
  },
  created() {
    this.getPartnerList();
    this.getCapacityMethod();
  },

  methods: {
    ...mapActions({
      getCapacity: "products/getCapacity",
      getPartners: "users/getPartners",
    }),
    getCapacityMethod(body) {
      this.isLoading = true;
      this.getCapacity(body)
        .then((res) => {
          this.isLoading = false;
          this.anomalyEvents = res.list;
          this.page = res.page;
          this.limit = res.limit;
          this.total = res.total;
          console.log(this.anomalyEvents);
        })
        .catch((err) => {
          console.log(err);
          this.isLoading = false;
          this.error = true;
        });
    },
    getPartnerList() {
      if (this.isSuperAdmin) {
        this.getPartners()
          .then((response) => {
            this.partnersWithId = response.result.map((partner) => {
              return { id: partner.id, name: partner.par_name };
            });
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    formatDateString(dateString) {
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = ("0" + (date.getMonth() + 1)).slice(-2);
      const day = ("0" + date.getDate()).slice(-2);
      const formattedDate = `${year}.${month}.${day}.`;
      return formattedDate;
    },
    handleFilter(hasPage, keydown) {
      if (keydown) {
        this.enterClicked = true;
      }
      const requestBody = {
        par_id: this.partner !== undefined ? this.partner : null,
        name: this.product_name !== undefined ? this.product_name : null,
        limit: this.limit,
        page: hasPage ? this.page : 1,
      };
      this.getCapacityMethod(requestBody);
      setTimeout(() => {
        this.enterClicked = false;
      }, 100);
    },
  },
  computed: {
    ...mapGetters({ loggedInUser: "users/loggedInUser" }),
    pageCount() {
      return Math.ceil(this.total / this.limit);
    },
    displayRange() {
      const start = (this.page - 1) * this.limit + 1;
      const end = Math.min(start + this.limit - 1, this.total);
      return `${start}-${end} of ${this.total}`;
    },
    isSuperAdmin() {
      return this.loggedInUser && this.loggedInUser.role === 0;
    },
  },
};
</script>

<style lang="scss" scoped></style>
